import React from "react";
import ModalHeader from "@/customComponents/uiComponents/modal/ModalHeader.jsx";
import {hopnLanguageArray} from "@/utils/functions.js";
import {afterPayImg} from "@img/index.js";

// Content-only body so it can render both as a standalone step (below) and inside
// a desktop `.upper-modal` popup (see carSelection.jsx) — mirrors payAfterDropoff.jsx.
export function InterestFreePaymentContent() {
    return (
        <div className="hopn-popup">
            <div className="hopn-popup-title" hopn-data-index="interest_title">
                {hopnLanguageArray("modal_car_selection", "interest_title", "4 Interest-free payments")}
            </div>
            <p className="hopn-popup-description" hopn-data-index="interest_desc">
                {hopnLanguageArray("modal_car_selection", "interest_desc", "Split your fare into 4 interest-free payments at checkout—no hidden fees, no extra charges!")}
            </p>
            <button className="hopn-afterpay-button" hopn-data-index="interest_afterpay">
                <img decoding="async" src={afterPayImg} alt={hopnLanguageArray("modal_car_selection", "afterpay_alt", "Afterpay")} hopn-data-index="afterpay_alt"/>
            </button>
        </div>
    );
}

export function InterestFreePayment({setStep, closeModal, previousStep}) {
    return (
        <>
            <ModalHeader title="" extraClasses="" totalSteps={0} cancelButton={false} backStep={previousStep} showBackButton={true} enableEditModeOnBackButton={false} setStep={setStep} closeModal={closeModal}/>
            <div className="modalPages-spacing pb-8">
                <InterestFreePaymentContent/>
            </div>
        </>
    );
}
export default InterestFreePayment;
